<template>
  <div class="counter-wrapper">
    <div id="rows_counter" class="card" @click="this.$router.push({ name: this.linkName })">
      <div v-if="isLoading === true" class="card-header">
        <ProgressBar mode="indeterminate" style="height: 6px; color: #fff;"></ProgressBar>
      </div>
      <div class="card-body">
        <p class="primary-title">{{ this.premier_titre }}</p>
        <div class="counter-content">
          <div class="icon-container">
            <img :src="icon" alt="image card" class="responsive-icon" />
          </div>
          <div class="text-container">
            <h2 class="counter-value">{{ compteur }} <span class="unit">{{ this.second_titre }}</span></h2>
            <p class="counter-description">{{ this.description }}</p>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="footer-content">
          <span class="details-text">Détails</span>
          <span class="details-icon"><i class="fa-solid fa-chevron-right"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Script reste inchangé
export default {
  name: 'RowsCounter',
  props: ['premier_titre', 'url', 'icon', 'second_titre', 'description', 'linkName'],
  data() {
    return {
      compteur: 0,
      isLoading: true
    }
  },
  async mounted() {
    await this.axios.get(this.url).then((response) => {
      this.compteur = response.data
      this.isLoading = false
    }).catch(() => {
      this.isLoading = false
      this.$toast.add({
        severity: 'error',
        summary: 'Probleme de connexion',
        detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
        life: 5000
      });
    })
  }
}
</script>

<style scoped>
.counter-wrapper {
  padding: 0.5rem;
  box-sizing: border-box;
}

#rows_counter {
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  background-color: #3242c5;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: none;
  display: flex;
  flex-direction: column;
}

#rows_counter:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card-body {
  padding: 1.25rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.primary-title {
  font-size: 0.9rem;
  opacity: 0.9;
  font-weight: 500;
  margin-bottom: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.counter-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.icon-container {
  width: 25%;
  min-width: 50px;
  max-width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.responsive-icon {
  width: 100%;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.text-container {
  flex: 1;
  padding-left: 0.75rem;
  overflow: hidden;
}

.counter-value {
  font-size: clamp(1.2rem, 3vw, 1.8rem);
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unit {
  font-size: 0.85em;
}

.counter-description {
  font-size: clamp(0.75rem, 2vw, 0.9rem);
  opacity: 0.9;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  border-top: none;
  padding: 0.75rem;
}

.footer-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.details-text {
  font-size: 0.85rem;
  font-weight: 500;
  margin-right: 0.5rem;
}

.details-icon {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}

/* Responsivité avancée */
@media (max-width: 1400px) {
  .card-body {
    padding: 1rem;
  }
}

@media (max-width: 992px) {
  .counter-value {
    font-size: clamp(1.1rem, 2.5vw, 1.5rem);
  }

  .icon-container {
    width: 22%;
  }
}

@media (max-width: 768px) {
  .counter-wrapper {
    padding: 0.4rem;
  }

  .card-body {
    padding: 0.9rem;
  }

  .counter-description {
    -webkit-line-clamp: 1;
  }
}

@media (max-width: 576px) {
  .card-body {
    padding: 0.75rem;
  }

  .card-footer {
    padding: 0.5rem 0.75rem;
  }

  .primary-title {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }

  .counter-value {
    margin-bottom: 0.25rem;
  }

  .details-text {
    font-size: 0.75rem;
  }
}
</style>